import { useEffect, useState } from 'react';
import { isNative } from '@/native';

/**
 * 该不该用手机端外壳（顶部工地 + 底部 Tab）。
 *
 * **判断依据是屏幕宽度，不只是「有没有装成 App」。**
 * 一开始只看 `isNative`，结果管理者在电脑浏览器里登录看到的还是桌面版左侧导航 ——
 * 而他正是在那儿预览手机端的。装成 App 是充分条件不是必要条件，
 * 真正决定用哪套导航的是屏幕有多宽。
 *
 * 768px 这个界限跟 Tailwind 的 md 断点对齐，管理端的左侧导航也是在这个宽度
 * 收成汉堡菜单的 —— 两处用同一个数，不会出现「导航收起来了但还是桌面版布局」。
 */
const MOBILE_MAX_WIDTH = 768;

export function useMobileShell(): boolean {
  const [narrow, setNarrow] = useState(() => isNarrowViewport());

  useEffect(() => {
    // 转屏、拖窗口大小都要跟着变，不能只在挂载时算一次
    const query = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH - 1}px)`);
    // 同样挡掉「量不出宽度」的一刻：媒体查询在宽度为 0 时也会判成窄屏
    const onChange = () => setNarrow(window.innerWidth > 0 && query.matches);
    onChange();
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);

  // 装成 App 时永远用手机端外壳：平板横屏也是手机端，那台设备上根本没有桌面版
  return isNative || narrow;
}

function isNarrowViewport(): boolean {
  try {
    const width = window.innerWidth;
    // 宽度为 0 说明这一刻根本量不出来（页面还没绘制、被隐藏、预渲染）。
    // 这时候当成宽屏 —— 猜错成手机端会把管理者甩进另一套导航，
    // 而猜错成桌面端只是多一次重排。
    if (width <= 0) return false;
    return width < MOBILE_MAX_WIDTH;
  } catch {
    return false;
  }
}
